/* JA金融機関コード */
import React, { useState, memo } from 'react';
import { FormControl, Button } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from './Paragraph';
import axios from 'axios';
import SelectJa from '../molecules/SelectJa';

interface Props {
  id: string;
  fm_id?: number;
  label: string;
  need?: boolean;
  value: string;
  placeholder: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  name?: string;
  help_msg?: string;
  disabled: boolean;
  jacode_disabled: boolean;
  maxlength?: number;
  looks_inactive?: boolean;
  user_jacode?: string;
  handleBlur: VoidFunction;
  handleFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  handleSelectJa?: (jacode: string, janame: string) => void;
}

interface JaInfo {
  ident_lv2_cd: string;
  name: string;
}

const initialErrorState = {
  email: '',
  email_confirmation: '',
  password: '',
  password_confirmation: '',
  ja_code: '',
};

const Jacode: React.FC<Props> = ({
  id,
  fm_id,
  label,
  need,
  value,
  placeholder,
  handleChange,
  handleBlur,
  message,
  name,
  help_msg,
  disabled,
  jacode_disabled,
  maxlength,
  looks_inactive,
  handleSelectJa,
}) => {
  const [open, setOpen] = useState(false); // モーダルの開閉フラグ

  // 閉じるボタン
  const handleClickClose = () => {
    setOpen(false);
  };

  // エラーメッセージ
  const [error_message, setErrorMessage] = useState(initialErrorState);

  // ポップアップ内のJA一覧を押下時
  const popupClick = (ja_info: JaInfo) => {
    //  エラー初期化
    setErrorMessage({ ...error_message, ja_code: '' });

    if (typeof handleSelectJa !== 'undefined') {
      handleSelectJa(ja_info.ident_lv2_cd, ja_info.name);
    }

    setOpen(false);
  };

  // onblur処理
  const handleFocusOut = () => {
    handleBlur();
    searchJa(value);
  };

  // JA検索
  const searchJa = async (ja_code: string): Promise<void> => {
    try {
      //  エラー初期化
      setErrorMessage({ ...error_message, ja_code: '' });

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/get_ja`, {
        ja_code: ja_code,
      });
      if (typeof handleSelectJa !== 'undefined') {
        handleSelectJa(ja_code, response.data.detail.ja_name);
      }
    } catch (error) {
      if (typeof handleSelectJa !== 'undefined') {
        handleSelectJa(ja_code, '');
      }
      console.error(error);
      alert(error.response.data.message);
    }
  };

  /**
   * 通常のJAコードを描画する
   * @return JSX.Element JAコードのElement
   */
  const returnJaCodeJsx = () => {
    return (
      <>
        <div className="text-btn_area">
          <FormControl
            className={(message || error_message.ja_code) && 'textarea-error'}
            id={id}
            data-fm_id={fm_id}
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            name={name}
            disabled={jacode_disabled}
            onBlur={handleFocusOut}
            maxLength={maxlength}
          />
          <Button
            size="sm"
            variant="success"
            className="btn-form"
            onClick={() => {
              setOpen(true);
            }}
            disabled={jacode_disabled}
          >
            選択
          </Button>
          <SelectJa toggleShow={open} toggleClose={handleClickClose} popupClick={popupClick} />
        </div>
        <div>
          {jacode_disabled ? (
            <Messages valid_msg={message ?? error_message.ja_code} />
          ) : (
            <Messages help_msg={help_msg} valid_msg={message ?? error_message.ja_code} />
          )}
        </div>
      </>
    );
  };

  /**
   * ラベルを描画する
   * @return JSX.Element ラベルのElement
   */
  const returnLabelJsx = () => {
    return <Paragraph label={value} />;
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={
        <div id={id} className="jacode-content">
          {disabled || looks_inactive ? returnLabelJsx() : returnJaCodeJsx()}
        </div>
      }
    />
  );
};

export default memo(Jacode);
